import { MultiStepFormState } from '@delmonicos/shared-design-system-react/src/contexts/multi-step-form-item';
import {
  MultiStepFormProvider,
  SubmitHandlerWithDirtyFields,
} from '@delmonicos/shared-design-system-react/src/contexts/multi-step-form.provider';
import { SetChargePointsLocationModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/charge-points/models/inputs/set-charge-points-location.model';
import { SubmitErrorHandler } from 'react-hook-form';

import { useUpdateLocationChargePointsContext } from '../../location.context';
import { LocationChargePointListUpdateFormStep1Controller } from '../location-charge-point-list-update-form-step-1/location-charge-point-list-update-form-step-1.controller';

export interface LocationChargePointListUpdateFormControllerProps {
  onError: SubmitErrorHandler<
    Pick<SetChargePointsLocationModel, 'chargePointIds' | 'locationId'>
  >;
  onSubmit: SubmitHandlerWithDirtyFields<
    Pick<SetChargePointsLocationModel, 'chargePointIds' | 'locationId'>
  >;
  onCancel: () => void;
  state: MultiStepFormState;
}

export const LocationChargePointListUpdateFormController = (
  props: LocationChargePointListUpdateFormControllerProps,
): React.JSX.Element => {
  const { onError, onSubmit, onCancel, state } = props;
  const data = useUpdateLocationChargePointsContext();

  return (
    <MultiStepFormProvider<
      Pick<SetChargePointsLocationModel, 'chargePointIds' | 'locationId'>
    >
      useFormProps={{
        mode: 'all',
        defaultValues: data,
      }}
      submitErrorHandler={onError}
      submitHandler={onSubmit}
      onCancel={onCancel}
      state={state}
      items={[
        {
          fields: ['chargePointIds'],
          component: <LocationChargePointListUpdateFormStep1Controller />,
        },
      ]}
    />
  );
};
